/** Also recognizes retained failures written before actionable feedback existed. */
export function extractionNeedsDocumentType(message: string | undefined): boolean {
  return Boolean(
    message &&
    /This job configures \d+ document types with \d+ fields between them, which is more than can be read in one pass, and this document did not match any single one of them\./.test(
      message,
    ),
  );
}
